export enum BookType {
    Childrens = 1,
    Technical = 2,
    Other = 3,
    School = 4,
    Scientific = 5,
    Art = 6,
    Museumcatalog = 7,
}